import React from 'react';
import { useNavigate } from 'react-router-dom';
import Photo from '../img/subodh_photo.png';

export default function Creator() {
  const navigate = useNavigate();
  const instagramLink = 'https://www.instagram.com/subodhsathe_/';
  const youtubeLink = 'https://www.youtube.com/@subodhsathe3034';

  return (
    <div style={{padding:16}}>
      <div style={{display:'flex', alignItems:'center', gap:8}}>
        <button onClick={() => navigate(-1)} style={{border:'none', background:'transparent', cursor:'pointer', fontSize:24}}>←</button>
        <h2 style={{margin:0}}>Creator</h2>
      </div>

      <div style={{marginTop:24, display:'flex', flexDirection:'column', alignItems:'center', gap:12}}>
        <div style={{width:220, height:320, borderRadius:18, overflow:'hidden', boxShadow:'0 6px 20px rgba(0,0,0,0.3)'}}>
          <img src={Photo} alt="Creator" style={{width:'100%',height:'100%',objectFit:'cover'}} />
        </div>
        <div style={{fontSize:20, fontWeight:700}}>Subodh Sathe</div>

        <div style={{display:'flex', gap:16}}>
          <a href={instagramLink} target="_blank" rel="noopener noreferrer" style={{textDecoration:'none'}} aria-label="Instagram">
            <div style={{width:46,height:46,borderRadius:10,display:'flex',alignItems:'center',justifyContent:'center',background:'#e1306c',color:'#fff',fontSize:22}}>📷</div>
          </a>
          <a href={youtubeLink} target="_blank" rel="noopener noreferrer" style={{textDecoration:'none'}} aria-label="YouTube">
            <div style={{width:46,height:46,borderRadius:10,display:'flex',alignItems:'center',justifyContent:'center',background:'#ff0000',color:'#fff',fontSize:22}}>▶️</div>
          </a>
        </div>

        <div style={{maxWidth:640,textAlign:'center',color:'var(--text)',marginTop:8,lineHeight:1.6}}>
          <p style={{margin:"0px", marginBottom:"98px"}}>Subodh Sathe is the creator of Linkalikes. He loves to do creative things and has a vision to put technology and creativity together to add some more beauty to life!</p>
        </div>
      </div>
    </div>
  );
}
